var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLengthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 27,
    viewBox: "0 0 55 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7266 1.36053H5.48218C3.00674 1.36053 1 3.36727 1 5.84271V21.5303C1 24.0058 3.00674 26.0125 5.48217 26.0125H34.7266M34.7266 1.36053H49.5178C51.9933 1.36053 54 3.36727 54 5.84271V13.6865M34.7266 1.36053V13.6865M34.7266 26.0125H49.5178C51.9933 26.0125 54 24.0058 54 21.5303V13.6865M34.7266 26.0125V13.6865M34.7266 13.6865H54",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2847 5.37339L41.0309 8.93142C40.967 9.0014 41.0158 9.11522 41.1099 9.11522H47.6173C47.7113 9.11522 47.7602 9.0014 47.6962 8.93142L44.4425 5.37339C44.3999 5.32679 44.3273 5.32679 44.2847 5.37339Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2847 22.3358L41.0309 18.7777C40.967 18.7077 41.0158 18.5939 41.1099 18.5939H47.6173C47.7113 18.5939 47.7602 18.7077 47.6962 18.7777L44.4425 22.3358C44.3999 22.3824 44.3273 22.3824 44.2847 22.3358Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.998 18.6169H17.3597M20.7213 18.6169H17.3597M17.3597 18.6169V8.98022H13.998",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLengthIcon);
export default __webpack_public_path__ + "static/media/LengthIcon.77f411b56bbe63688d23f8b35e0150df.svg";
export { ForwardRef as ReactComponent };